import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardContent, Typography, Box } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import ApiService from '../../base/api/ApiService';
import CommonHeader from '../../base/views/CommonHeader';
import { Student } from '../../components/models/Student';
import { Announcement } from '../../components/models/Announcement';

const StudentList: React.FC = () => {
    const navigate = useNavigate();
    const [students, setStudents] = useState<Student[]>([]);
    const [unreadAnnouncements, setUnreadAnnouncements] = useState<Announcement[]>([]);

    useEffect(() => {
        loadStudentList();
        loadAnnouncements();
    }, []);

    const loadStudentList = async () => {
        try {
            const response = await ApiService.getStudents();
            setStudents(response || []);
        } catch (error) {
            console.error('Error loading student list:', error);
        }
    };

    const loadAnnouncements = async () => {
        try {
            const list = await ApiService.getActiveAnnouncements();
            setUnreadAnnouncements(list.filter((a) => !a.isRead).slice(0, 3));
        } catch (error) {
            console.error('Error loading announcements:', error);
        }
    };

    const viewStudentDetails = (studentId: string | null) => {
        navigate(`/students/${studentId}`);
    };

    return (
        <div>
            <CommonHeader title="Список учеников" showBackButton={false} />

            {unreadAnnouncements.length > 0 && (
                <Box sx={{ m: '5px', mb: 0 }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ px: 1, pt: 1 }}>
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <CampaignIcon fontSize="small" color="primary" />
                            <Typography variant="subtitle2" fontWeight="bold">Объявления</Typography>
                        </Box>
                        <Typography
                            variant="caption"
                            color="primary"
                            sx={{ cursor: 'pointer' }}
                            onClick={() => navigate('/announcements')}
                        >
                            Все объявления
                        </Typography>
                    </Box>
                    {unreadAnnouncements.map((a) => (
                        <Card
                            key={a.id}
                            sx={{ m: '5px', cursor: 'pointer', borderLeft: '4px solid #fd5508' }}
                            onClick={() => navigate(`/announcements/${a.id}`)}
                        >
                            <CardContent sx={{ py: '8px !important' }}>
                                <Typography variant="body2" fontWeight="bold">{a.name}</Typography>
                                {(a.announce || a.message) && (
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                        sx={{
                                            overflow: 'hidden',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: 'vertical'
                                        }}
                                    >
                                        {a.announce || a.message}
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            )}

            {students.map((student) => (
                <Card key={student.id} style={{ marginBottom: '10px', margin: '5px' }}>
                    <CardContent>
                        <Typography variant="h6">{student.name}</Typography>
                        <Box mt={1} display="flex" flexDirection="row">
                            <Typography color="textSecondary">Группа:</Typography>
                            <Typography color="textSecondary">{student.groupName}</Typography>
                        </Box>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => viewStudentDetails(student?.id)}
                            style={{ marginTop: '10px' }}
                        >
                            Подробнее
                        </Button>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};

export default StudentList;
